import { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Reports.css';
import MarketingdashboardAside from './MarketingdashboardAside';

const API_BASE = 'https://cleezoclass.com:8443/api';

const reportTabs = [
  { id: 'centralization', label: 'Centralization' },
  { id: 'amounts', label: 'Account' },
  { id: 'followup', label: 'Follow-up' },
  { id: 'mou', label: 'MOU Forms' },
  { id:'payment', label:" Amount"}
  
];

const reportsInlineStyles = `
  .reports-page {
    min-height: 100vh;
    padding: 24px;
    background: #ffffff;
    color: #111827;
    font-family: Arial, Helvetica, sans-serif;
    overflow-x: hidden;
  }

  .reports-header {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
    padding: 20px 22px;
    border-radius: 20px;
    background: #ffffff;
    color: #111827;
    border: 1px solid #e5e7eb;
    box-shadow: 0 8px 24px rgba(17, 24, 39, 0.06);
  }

  .reports-header h1 {
    margin: 0;
    font-size: 2rem;
    font-weight: 800;
    letter-spacing: 0.02em;
  }

  .reports-header p {
    margin: 8px 0 0;
    color: #6b7280;
    font-size: 0.95rem;
  }

  .reports-header-actions {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
  }

  .reports-back-link,
  .reports-logout-btn,
  .reports-tab {
    border: 0;
    border-radius: 999px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  }

  .reports-back-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 11px 18px;
    background: #ffffff;
    color: #111827;
    text-decoration: none;
    border: 1px solid #d1d5db;
  }

  .reports-logout-btn {
    padding: 11px 18px;
    background: #ffffff;
    color: #111827;
    border: 1px solid #d1d5db;
    box-shadow: 0 8px 20px rgba(17, 24, 39, 0.06);
  }

  .reports-tabs {
    display: flex;
    gap: 10px;
    // margin: 18px 0;
    overflow-x: auto;
    flex-wrap: nowrap;
    padding-bottom: 4px;
  }

  .reports-tab {
    flex: 1 1 0;
    min-width: 0;
    padding: 12px 18px;
    background: #ffffff;
    color: #374151;
    border: 1px solid #e5e7eb;
    box-shadow: 0 8px 18px rgba(17, 24, 39, 0.05);
    white-space: nowrap;
    text-align: center;
  }

  .reports-tab.active {
    background: #f3f4f6;
    color: #111827;
    border-color: #d1d5db;
    box-shadow: 0 8px 18px rgba(17, 24, 39, 0.05);
  }

  .reports-body {
    padding: 22px;
    border-radius: 24px;
    background: #ffffff;
    box-shadow: 0 12px 30px rgba(17, 24, 39, 0.06);
    overflow: hidden;
  }

  .reports-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 16px;
    margin-bottom: 22px;
  }

  .reports-card {
    padding: 18px;
    border-radius: 18px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    box-shadow: 0 8px 18px rgba(17, 24, 39, 0.04);
  }

  .reports-card span {
    display: block;
    margin-bottom: 8px;
    color: #6b7280;
    font-size: 0.92rem;
    font-weight: 700;
  }

  .reports-card strong {
    font-size: 1.9rem;
    color: #111827;
  }

  .reports-loading,
  .reports-error,
  .reports-empty {
    padding: 20px;
    border-radius: 16px;
    text-align: center;
    font-weight: 700;
  }

  .reports-loading {
    background: #ffffff;
    color: #111827;
    border: 1px solid #e5e7eb;
  }

  .reports-error {
    background: #ffffff;
    color: #111827;
    border: 1px solid #e5e7eb;
  }

  .reports-empty {
    background: #ffffff;
    color: #6b7280;
    border: 1px solid #e5e7eb;
  }

  .reports-table-shell {
    border-radius: 20px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    box-shadow: 0 14px 32px rgba(15, 23, 42, 0.08);
  }

  .reports-table-head {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
    padding: 18px 20px;
    background: #ffffff;
    color: #111827;
    border-bottom: 1px solid #e5e7eb;
  }

  .reports-table-head h2 {
    margin: 0;
    font-size: 1.25rem;
  }

  .reports-table-head p {
    margin: 6px 0 0;
    color: #6b7280;
  }

  .reports-table-chip {
    padding: 8px 14px;
    border-radius: 999px;
    background: #ffffff;
    color: #111827;
    border: 1px solid #d1d5db;
    font-size: 0.85rem;
    font-weight: 700;
  }

  .reports-table-wrap {
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    max-width: 100%;
    scrollbar-gutter: stable;
    overscroll-behavior-x: contain;
    padding-bottom: 8px;
  }

  .reports-table {
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
    table-layout: auto;
  }

  .reports-table th,
  .reports-table td {
    padding: 14px 16px;
    text-align: left;
    border-bottom: 1px solid #e2e8f0;
    vertical-align: top;
    white-space: nowrap;
    word-break: normal;
    overflow-wrap: normal;
  }

  .reports-table th {
    position: sticky;
    top: 0;
    background: #ffffff;
    color: #111827;
    font-size: 0.92rem;
    white-space: nowrap;
  }

  .reports-table tbody tr:nth-child(even) {
    background: #fafafa;
  }

  .reports-table tbody tr:hover {
    background: #f3f4f6;
  }

  @media (max-width: 960px) {
    .reports-header,
    .reports-table-head {
      flex-direction: column;
      align-items: flex-start;
    }

    .reports-summary {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 640px) {
    .reports-page {
      padding: 14px;
    }

    .reports-body {
      padding: 14px;
    }

    .reports-summary {
      grid-template-columns: 1fr;
    }
  }
`;

function buildColumns(rows) {
  if (!rows || rows.length === 0) return [];
  return Object.keys(rows[0]);
}

function humanizeColumnName(column) {
  if(column === "advanceAmount") return "First installment"
  if(column === "advancePaidDate") return "First installment Paid Date"
  if(column === "mou_file_path") return "Signed PDF"
  return column
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
}

function ensureArray(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.rows)) return payload.rows;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.result)) return payload.result;
  return [];
}

function getComparableSortValue(row, columns) {
  const priorityColumns = [
    'id',
    'report_id',
    'followup_id',
    'mou_id',
    'centralization_id',
    'created_at',
    'createdAt',
    'updated_at',
    'updatedAt',
    'executedDate',
    'submission_date',
    'date',
  ];

  const columnsToCheck = [...priorityColumns, ...(columns || [])];

  for (const column of columnsToCheck) {
    const value = row?.[column];
    if (value === null || value === undefined || value === '') continue;

    const numericValue = Number(value);
    if (!Number.isNaN(numericValue) && String(value).trim() !== '') {
      return { value: numericValue, type: 'number' };
    }

    if (typeof value === 'string') {
      const parsedDate = new Date(value);
      if (!Number.isNaN(parsedDate.getTime())) {
        return { value: parsedDate.getTime(), type: 'date' };
      }
    }
  }

  return { value: null, type: 'none' };
}

function formatCell(value) {
  if (value === null || value === undefined || value === '') return '-';
  if (typeof value === 'string') {
    const isoDateMatch = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?$/.test(value);
    if (isoDateMatch) {
      const parsedDate = new Date(value);
      if (!Number.isNaN(parsedDate.getTime())) {
        return parsedDate.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        });
      }
    }
  }
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

function ReportTable({ rows, emptyMessage }) {
  const safeRows = useMemo(() => (Array.isArray(rows) ? rows : []), [rows]);
  const columns = useMemo(() => buildColumns(safeRows), [safeRows]);
  const tableMinWidth = useMemo(() => Math.max(columns.length * 180, 1400), [columns.length]);
  const displayRows = useMemo(() => {
    const withSortValues = safeRows.map((row, index) => ({
      row,
      index,
      sortValue: getComparableSortValue(row, columns),
    }));

    const hasSortableValue = withSortValues.some(
      (item) => item.sortValue.type !== 'none'
    );

    if (!hasSortableValue) {
      return safeRows;
    }

    return withSortValues
      .slice()
      .sort((a, b) => {
        if (a.sortValue.type !== 'none' && b.sortValue.type !== 'none') {
          return b.sortValue.value - a.sortValue.value;
        }
        if (a.sortValue.type !== 'none') return -1;
        if (b.sortValue.type !== 'none') return 1;
        return a.index - b.index;
      })
      .map((item) => item.row);
  }, [columns, safeRows]);
  const title =
    emptyMessage.includes('centralization')
      ? 'Centralization'
      : emptyMessage.includes('amount')
        ? 'Amount'
        : emptyMessage.includes('follow-up')
          ? 'Follow-up'
          :emptyMessage.includes('mou')
          ? 'MOU Forms'
          :'';

  if (displayRows.length === 0) {
    return <div className="reports-empty">{emptyMessage}</div>;
  }

  return (
    <div className="reports-table-shell">
      {/* <MarketingdashboardAside /> */}
      <div className="reports-table-head">
        <div>
          <h2>{title}</h2>
          <p>
            Showing {displayRows.length} record{displayRows.length === 1 ? '' : 's'}
          </p>
        </div>
        <span className="reports-table-chip">Scrollable table</span>
      </div>
      <div
        className="reports-table-wrap"
        onWheel={(event) => {
          const isMostlyVerticalScroll = Math.abs(event.deltaY) >= Math.abs(event.deltaX);
          if (!isMostlyVerticalScroll) return;
          event.currentTarget.scrollLeft += event.deltaX;
          event.preventDefault();
        }}
      >
        <table
          className="reports-table"
          style={{ width: `${tableMinWidth}px`, minWidth: `${tableMinWidth}px` }}
        >
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column}>{humanizeColumnName(column)
                }</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {displayRows.map((row, index) => (
              <tr key={row.id || row.followup_id || index}>
                {columns.map((column) => (
<td key={column}>
  {column === "paymentUpload" && row[column] ? (
    <img
      src={`https://cleezoclass.com:8443/${row[column]}`}
      alt="payment"
      style={{
        width: "80px",
        height: "80px",
        objectFit: "cover",
        borderRadius: "6px",
        cursor: "pointer"
      }}
      onClick={() => window.open(`https://cleezoclass.com:8443/${row[column]}`, "_blank")}
    />
  ) : column === "mou_file_path" && row[column] ? (
    <button
      type="button"
      onClick={() => window.open(`https://cleezoclass.com:8443/${row[column]}`, "_blank")}
      style={{
        border: '0',
        borderRadius: '999px',
        padding: '8px 14px',
        background: '#1d4ed8',
        color: '#fff',
        cursor: 'pointer',
        fontWeight: 700,
      }}
    >
      View PDF
    </button>
  ) : (
    formatCell(row[column])
  )}
</td>                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function Reports() {
  const navigate = useNavigate();
  const [empId, setEmpId] = useState('');
  const [empName, setEmpName] = useState('');
  const [designation, setDesignation] = useState('');
  const [activeTab, setActiveTab] = useState('centralization');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [centralizationRows, setCentralizationRows] = useState([]);
  const [amountRows, setAmountRows] = useState([]);
  const [followupRows, setFollowupRows] = useState([]);
  const [mouRows, setMouRows] = useState([]);
  const [paymentRows,setPaymentRows] = useState([])

  useEffect(() => {
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');

    if (!storedEmpId || !storedEmpName || !storedDesignation) {
      alert('Session expired. Please log in again.');
      navigate('/');
      return;
    }

    setEmpId(storedEmpId);
    setEmpName(storedEmpName);
    setDesignation(storedDesignation);
  }, [navigate]);

  useEffect(() => {
    const loadReports = async () => {
      try {
        setLoading(true);
        setError('');

        const [centralizationRes, amountRes, followupRes, mouRes,paymentRes] = await Promise.all([
          axios.get(`${API_BASE}/reports/centralization`),
          axios.get(`${API_BASE}/reports/mou-amounts`),
          axios.get(`${API_BASE}/follow-ups-all`),
          axios.get(`${API_BASE}/reports/mou-forms`),
          axios.get(`https://cleezoclass.com:8443/api/mou/get-payment`)
        ]);

        const centralizationData = ensureArray(centralizationRes.data);
        const amountData = ensureArray(amountRes.data);
        const followupData = ensureArray(followupRes.data);
        const mouData = ensureArray(mouRes.data);
        const paymentData = Array.isArray(paymentRes.data)
          ? paymentRes.data
          : paymentRes.data
            ? [paymentRes.data]
            : [];
          

         console.log(centralizationData)
        console.log('[reports] centralization response rows:', centralizationData.length);
        console.log('[reports] amount response rows:', amountData.length);
        console.log('[reports] follow-up response rows:', followupData.length);
        console.log('[reports] mou response rows:', mouData.length);
        console.log('[reports] payment response rows:', paymentData.length)

        setCentralizationRows(centralizationData);
        setAmountRows(amountData);
        setFollowupRows(followupData);
        setMouRows(mouData);
        setPaymentRows(paymentData)
      } catch (err) {
        console.error('Failed to load reports:', err);
        console.error('[reports] centralization fetch status:', err?.response?.status);
        console.error('[reports] centralization fetch data:', err?.response?.data);
        setError('Failed to load report data.');
      } finally {
        setLoading(false);
      }
    };

    loadReports();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('empId');
    localStorage.removeItem('empName');
    localStorage.removeItem('designation');
    navigate('/');
  };

  const activeData =
    activeTab === 'centralization'
      ? centralizationRows
      : activeTab === 'amounts'
        ? amountRows
        : activeTab === 'followup'
          ? followupRows
          :activeTab === 'mou'
          ? mouRows
          :paymentRows;

  const emptyMessage =
    activeTab === 'centralization'
      ? 'No centralization data found.'
      : activeTab === 'amounts'
        ? 'No amount data found.'
        : activeTab === 'followup'
          ?'No follow-up data found.'
          : activeTab==='mou'
          ? 'No MOU form data found.'
          :'No Amounts data found';

  return (
    <div className="reports-page">
      {/* <MarketingdashboardAside /> */}
      <style>{reportsInlineStyles}</style>

      <div className="reports-tabs">
        {reportTabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`reports-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="reports-body">
        {loading ? (
          <div className="reports-loading">Loading reports...</div>
        ) : error ? (
          <div className="reports-error">{error}</div>
        ) : (
          <>
            <div className="reports-summary">
              <div className="reports-card">
                <span>Centralization</span>
                <strong>{centralizationRows.length}</strong>
              </div>
              <div className="reports-card">
                <span>Account</span>
                <strong>{amountRows.length}</strong>
              </div>
              <div className="reports-card">
                <span>Follow-up</span>
                <strong>{followupRows.length}</strong>
              </div>
              <div className="reports-card">
                <span>MOU Forms</span>
                <strong>{mouRows.length}</strong>
              </div>
              <div className='reports-card'>
                <span>Amounts</span>
                <strong>{paymentRows.length}</strong>
              </div>
            </div>

            <ReportTable rows={activeData} emptyMessage={emptyMessage} />
          </>
        )}
      </div>
    </div>
  );
}
